export const columnLetter = (col: number): string => {
  let n = col;
  let s = "";
  while (true) {
    s = String.fromCharCode(65 + (n % 26)) + s;
    if (n < 26) break;
    n = Math.floor(n / 26) - 1;
  }
  return s;
};
